import React from "react";
import ShopBtn from "./btn/ShopBtn";
import { createArrOfObj } from "./utils";

export default class Shop extends React.Component {
  render() {
    const BtnsValues = new Array(5)
      .fill("")
      .map((el, indx) => indx + 1);
    const btnsPricesEasy = [10, 18, 27, 35, 43]

    const valuesAndPrices = createArrOfObj(BtnsValues, btnsPricesEasy)
    
    return (
      <ShopBtns 
        value={valuesAndPrices} 
        handleClick={this.props.clickBtnPlus}
        disabled={this.props.plusPoints ? false : true}
        />
    )
  }
}

class ShopBtns extends React.Component {

  render() {

    return (
      <div className="shop">
        {this.props.value.map(el => <ShopBtn 
          key={el.id}
          plus={el} 
          handleClick={this.props.handleClick}
          disabled={this.props.disabled}
        />)}
      </div>
    )
  }
}
